import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposServicioMailingConstant } from 'constants/index'

const MailingServiceFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO SERVICIO' htmlFor='input-mailingService' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='mailingService'>
          {({ field }) => (
            <Form.Select {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-mailingService'>
              <option value=''>Seleccionar</option>
              {TiposServicioMailingConstant.__array.map((val, key) => {
                return (
                  <option key={key} value={val.id}>
                    {val.nombre}
                  </option>
                )
              })}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MailingServiceFormGroup)
